import InteractiveAnnotation from "./interactiveAnnotation";
import { isInBoundsBox, isInBoundsLine, angleOffset } from "../geometry";
import { setLineStyle } from "../canvasUtils";

export default class Line extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);
    this.headX = position.x;
    this.headY = position.y;
    this.tailX = position.x;
    this.tailY = position.y;

    this.fixedDimensions = false;

    this.activeTail = false;
    this.activeHead = false;
    this.activeBodyOffset = false;

    this.headOffset = 0;
  }

  get angle() {
    return Math.atan2(this.dy, this.dx);
  }

  get length() {
    return Math.sqrt(this.dx * this.dx + this.dy * this.dy);
  }

  get dy() {
    return this.tailY - this.headY;
  }

  get dx() {
    return this.tailX - this.headX;
  }

  get isActive() {
    return this.activeTail || this.activeHead || this.activeBodyOffset;
  }

  get interactionPoints() {
    return [{ x: this.headX, y: this.headY }, { x: this.tailX, y: this.tailY }];
  }

  draw(ctx) {
    setLineStyle(ctx, this);

    ctx.beginPath();
    ctx.moveTo(this.tailX, this.tailY);

    // shift the head a little bit so that the tip of the arrow is sharp
    let head = {x: this.headX, y: this.headY};
    if (this.headOffset) {
      let offset = angleOffset(this.headOffset, this.angle);
      head.x += offset.x;
      head.y += offset.y;
    }
    ctx.lineTo(head.x, head.y);
    ctx.stroke();
    ctx.closePath();
  }

  isInBounds(x, y){
    return isInBoundsBox(x, y, this.headX, this.headY, this.transform.zoom)
      || isInBoundsBox(x, y, this.tailX, this.tailY, this.transform.zoom)
      || isInBoundsLine(x, y, this.headX, this.headY, this.tailX, this.tailY);
  }

  mousedown(x, y){
    super.mousedown(x, y);
    this.clearActiveState();

    if (!this.fixedDimensions && isInBoundsBox(x, y, this.tailX, this.tailY, this.transform.zoom)) 
      this.activeTail = true;
    else if (!this.fixedDimensions && isInBoundsBox(x, y, this.headX, this.headY, this.transform.zoom)) 
      this.activeHead = true;
    else this.activeBodyOffset = true;
  }

  mousemove(x, y){
    const { dx, dy } = this.getAndUpdateInteraction(x, y);

    if (!this.fixedDimensions && this.activeTail) this.updateTail(dx, dy);
    else if (!this.fixedDimensions && this.activeHead) this.updateHead(dx, dy);
    else if (this.activeBodyOffset) this.updateLine(dx, dy);
  }

  updateTail(dx, dy) {
    this.tailX += dx;
    this.tailY += dy;
  }

  setTail(x, y){
    this.tailX = x;
    this.tailY = y;
  }

  updateHead(dx, dy) {
    this.headX += dx;
    this.headY += dy;
  }

  updateLine(dx, dy) {
    this.updateHead(dx,dy);
    this.updateTail(dx,dy);
  }

  clearActiveState(){
    this.activeTail = false;
    this.activeHead = false;
    this.activeBodyOffset = false;
  }
}